import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store';
import VueScrollTo from 'vue-scrollto';

Vue.use(Router);

//export default new Router({
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'chatbot',
      component: Home
    },
    {
        path: '/thankyou',
        name: 'thankyou',
        component: () => import(/* webpackChunkName: "apply" */ './views/form/ThankYou.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
        path: '/signin',
        name: 'signin',
        component: () => import(/* webpackChunkName: "signin" */ './views/Signin.vue'),
    },
    {
        path: '/users',
        name: 'users',
        children: [
            {
                name: 'returning',
                path: 'returning',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.auth.confirmedUser) {
                        next('/');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "wReturning" */ './views/wizard/WizardReturningUser.vue')
            },
            {
                name: 'processingShort',
                path: 'processing',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.returnStep) {
                        next('/users/returning');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "wReturning" */ './views/form/Processing.vue')
            },
        ],
        component: () => import(/* webpackChunkName: "wizard" */ './views/Wizard.vue')
    },
    {
        path: '/apply',
        name: 'apply',
        children: [
            {
                name: 'apply1',
                path: '1',
                component: () => import(/* webpackChunkName: "apply" */ './views/wizard/WizardStep1.vue'),
                alias: ['/apply']
            },
            {
                name: 'apply2',
                path: '2',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.firstStep) {
                        // next();
                        next('/apply/1');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/wizard/WizardStep2.vue'),
            },
            {
                name: 'apply3',
                path: '3',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.step2) {
                        //next();
                        next('/apply/2');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/wizard/WizardStep3.vue'),
            },
            {
                name: 'apply4',
                path: '4',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.step3) {
                        // next();
                        next('/apply/3');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/wizard/WizardStep4.vue'),
            },
            {
                name: 'apply4reject',
                path: '4/declined',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.step4) {
                        // next();
                        next('/apply/4');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/wizard/Wizard4Reject.vue'),
            },
            {
                name: 'apply5',
                path: '5',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.step4) {
                        // next();
                        next('/apply/4');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/wizard/WizardStep5.vue'),
            },
            {
                name: 'apply6',
                path: '6',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.step5) {
                        // next();
                        next('/apply/5');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/wizard/WizardStep6.vue'),
            },
            {
                name: 'sending',
                path: 'sending',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.step6) {
                        next('/apply/6');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/form/Sending.vue')
            },
            {
                name: 'sending',
                path: 'sending',
                beforeEnter: (to, from, next) => {
                    if (!store.state.home.formData.step6) {
                        next('/apply/6');
                    } else {
                        next();
                    }
                },
                component: () => import(/* webpackChunkName: "apply" */ './views/form/Sending.vue')
            },
        ],
        component: () => import(/* webpackChunkName: "wizard" */ './views/Wizard.vue')
    },
    {
        name: 'declined',
        path: '/declined',

        beforeEnter: (to, from, next) => {
            if (store.state.home.formData.apiResponse !== 'interstitial') {
                next('/');
            } else {
                next();
            }
        },

        component: () => import(/* webpackChunkName: "interstitial" */ './views/Interstitial.vue')
    },
    {
        path: '/unsubscribe',
        name: 'unsubscribe',
        children: [
        {
            name: 'unsubscribe-index',
            path: 'index',
            component: () => import(/* webpackChunkName: "unsubscribe" */ './views/unsubscribe/UnsubscribeIndex.vue'),
            alias: ['/unsubscribe']
        },
        {
          name: 'unsubscribe-email',
          path: 'email',
          component: () => import(/* webpackChunkName: "unsubscribe" */ './views/unsubscribe/UnsubscribeEmail.vue'),
        },
        {
            name: 'unsubscribe-phone',
            path: 'phone',
            component: () => import(/* webpackChunkName: "unsubscribe" */ './views/unsubscribe/UnsubscribePhone.vue'),
          },
        ],
        component: () => import(/* webpackChunkName: "unsubscribe" */ './views/Unsubscribe.vue')
    },
    {
        path: '/legal',
        name: 'legal',
        children: [
        {
          name: 'tos',
          path: 'tos',
          component: () => import(/* webpackChunkName: "legal" */ './views/legal/Tos.vue'),
          alias: ['/legal']
        },
        {
            name: 'privacy',
            path: 'privacy',
            component: () => import(/* webpackChunkName: "legal" */ './views/legal/Privacy.vue'),
        },
        {
            name: 'california',
            path: 'california',
            component: () => import(/* webpackChunkName: "legal" */ './views/legal/California.vue'),
        },
        {
            name: 'disclaimer',
            path: 'disclaimer',
            component: () => import(/* webpackChunkName: "legal" */ './views/legal/Disclaimer.vue'),
        },
        {
            name: 'e-consent',
            path: 'e-consent',
            component: () => import(/* webpackChunkName: "legal" */ './views/legal/Econsent.vue'),
        },
        {
            name: 'partners',
            path: 'partners',
            component: () => import(/* webpackChunkName: "legal" */ './views/legal/Partners.vue'),
        },
        ],
        component: () => import(/* webpackChunkName: "legal" */ './views/Legal.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {

    if (to.hash) {
        VueScrollTo.scrollTo(to.hash, 700);
        return { selector: to.hash }
    } else {
        return { x: 0, y: 0 }
    }
    //return { x: 0, y: 0 }
  }  
});

router.afterEach(( to, from ) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': to.path,
    'pageTitle': to.name
    });
});

export default router;